import { Link } from 'react-router-dom';
import { mockTracks } from '../../../mocks/music';

export default function FeaturedMusic() {
  const featured = mockTracks.filter((t) => t.featured);

  return (
    <section className="bg-brand-dark py-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-4 mb-12">
          <div>
            <p className="font-heading font-light text-brand-orange tracking-[0.3em] uppercase text-xs mb-2">
              Latest Tracks
            </p>
            <h2 className="font-display text-5xl md:text-6xl text-white tracking-wide">
              FEATURED <span className="text-brand-yellow">MUSIC</span>
            </h2>
          </div>
          <a
            href="https://dirtybirdy.bandcamp.com/music"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap font-heading font-semibold text-xs tracking-widest uppercase text-brand-yellow border border-brand-yellow px-6 py-2.5 hover:bg-brand-yellow hover:text-black transition-colors duration-200 cursor-pointer"
          >
            Full Discography
          </a>
        </div>

        {/* Track Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((track) => (
            <div
              key={track.id}
              className="group bg-brand-card overflow-hidden cursor-pointer"
            >
              {/* Cover */}
              <div className="relative w-full h-0 pb-[100%] overflow-hidden">
                <img
                  src={track.coverUrl}
                  alt={track.title}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-brand-yellow">
                    <i className="ri-play-fill text-black text-2xl" />
                  </div>
                </div>
              </div>

              {/* Info */}
              <div className="p-5">
                <h3 className="font-display text-2xl text-white tracking-wide mb-2">
                  {track.title}
                </h3>
                <p className="font-body text-white/50 text-sm leading-relaxed line-clamp-2 mb-4">
                  {track.description}
                </p>
                <div className="flex items-center gap-3">
                  <a
                    href={track.bandcampUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whitespace-nowrap font-heading font-semibold text-xs tracking-widest uppercase bg-brand-yellow text-black px-4 py-2 hover:bg-brand-orange hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    Listen
                  </a>
                  <a
                    href={track.downloadUrl}
                    className="whitespace-nowrap font-heading font-semibold text-xs tracking-widest uppercase border border-white/30 text-white/70 px-4 py-2 hover:border-brand-yellow hover:text-brand-yellow transition-colors duration-200 cursor-pointer"
                  >
                    Buy
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
